export const sceneBuild = [
    {
      "name": "Base",
      "view": "Landscape",
      "scheme": 1,
      "imageUrl": require("../static/Landscape/landscape1-MASK-base1.png"),
      "imageUrl2": require("../static/Landscape/landscape1-MASK-base1-2.png")
    },
    {
      "name": "MULTIPLY",
      "view": "Landscape",
      "scheme": 1,
      "imageUrl": require("../static/Landscape/landscape1-MULTIPLY-shadows.png"),
      "imageUrl2": ""
    },
    {
      "name": "zPrime",
      "view": "Landscape",
      "scheme": 1,
      "imageUrl": require("../static/Landscape/landscape1-MASK-zahner1.png"),
      "imageUrl2": ""
    },
    {
      "name": "zSec",
      "view": "Landscape",
      "scheme": 1,
      "imageUrl": require("../static/Landscape/landscape1-MASK-zahner2.png"),
      "imageUrl2": ""
    },
    {
      "name": "wood",
      "view": "Landscape",
      "scheme": 1,
      "imageUrl": require("../static/Landscape/landscape1-MASK-wood.png"),
      "imageUrl2": ""
    },
    {
      "name": "tile",
      "view": "Landscape",
      "scheme": 1,
      "imageUrl": require("../static/Landscape/landscape1-MASK-tile.png"),
      "imageUrl2": ""
    },
    {
      "name": "industrial",
      "view": "Landscape",
      "scheme": 1,
      "imageUrl": require("../static/Landscape/landscape1-MASK-industrial.png"),
      "imageUrl2": ""
    },
    {
      "name": "Base",
      "view": "Landscape",
      "scheme": 2,
      "imageUrl": require("../static/Landscape/landscape3-BASE.png"),
      "imageUrl2": require("../static/Landscape/landscape3-BASE.png")
      // "imageUrl": require("../static/Landscape/landscape2-BASE.png")
    },
    {// need to update
      "name": "MULTIPLY",
      "view": "Landscape",
      "scheme": 2,
      "imageUrl": require("../static/Landscape/landscape3-MULTIPLY-shadows.png"),
      // "imageUrl": require("../static/Landscape/landscape3-MULTIPLY-shadows.jpg"),
      "imageUrl2": ""
    },
    {
      "name": "zPrime",
      "view": "Landscape",
      "scheme": 2,
      "imageUrl": require("../static/Landscape/landscape3-MASK-zahner1.png"),
      "imageUrl2": ""
    },
    {
      "name": "zSec",
      "view": "Landscape",
      "scheme": 2,
      "imageUrl": require("../static/Landscape/landscape3-MASK-zahner2.png"),
      "imageUrl2": ""
    },
    {
      "name": "wood",
      "view": "Landscape",
      "scheme": 2,
      "imageUrl": require("../static/Landscape/landscape3-MASK-wood.png"),
      "imageUrl2": ""
    },
    {
      "name": "tile",
      "view": "Landscape",
      "scheme": 2,
      "imageUrl": require("../static/Landscape/landscape3-Mask-tile.png"),
      "imageUrl2": ""
    },
    {
      "name": "industrial",
      "view": "Landscape",
      "scheme": 2,
      "imageUrl": require("../static/Landscape/landscape3-Mask-industrial.png"),
      "imageUrl2": ""
    },
    {
      "name": "Base",
      "view": "Landscape",
      "scheme": 3,
      "imageUrl": require("../static/Landscape/landscape2-BASE.png"),
      "imageUrl2": require("../static/Landscape/landscape2-BASE-2.png")
      // "imageUrl": require("../static/Landscape/landscape2-BASE.png")
    },
    {
      "name": "MULTIPLY",
      "view": "Landscape",
      "scheme": 3,
      "imageUrl": require("../static/Landscape/landscape2-MULTIPLY-shadows.png"),
      "imageUrl2": ""
    },
    {
      "name": "zPrime",
      "view": "Landscape",
      "scheme": 3,
      "imageUrl": require("../static/Landscape/landscape2-MASK-zahner1.png"),
      "imageUrl2": ""
    },
    {
      "name": "zSec",
      "view": "Landscape",
      "scheme": 3,
      "imageUrl": require("../static/Landscape/landscape2-MASK-zahner2.png"),
      "imageUrl2": ""
    },
    {
      "name": "wood",
      "view": "Landscape",
      "scheme": 3,
      "imageUrl": require("../static/Landscape/landscape2-MASK-wood.png"),
      "imageUrl2": ""
    },
    {
      "name": "tile",
      "view": "Landscape",
      "scheme": 3,
      "imageUrl": require("../static/Landscape/landscape2-MASK-tile.png"),
      "imageUrl2": ""
    },
    {
      "name": "industrial",
      "view": "Landscape",
      "scheme": 3,
      "imageUrl": require("../static/Landscape/landscape2-Mask-industrialfix.png"),
      "imageUrl2": ""
    },
    

    {
      "name": "Base",
      "view": "Room",
      "scheme": 1,
      "imageUrl": require("../static/Room/room1-BASE.png"),
      "imageUrl2": ""
    },
    {
      "name": "MULTIPLY",
      "view": "Room",
      "scheme": 1,
      "imageUrl": require("../static/Room/room1-MULTIPLY.png"),
      "imageUrl2": ""
    },
    {
      "name": "zPrime",
      "view": "Room",
      "scheme": 1,
      "imageUrl": require("../static/Room/room1-MASK-Zahner1.png"),
      "imageUrl2": ""
    },
    {
      "name": "zSec",
      "view": "Room",
      "scheme": 1,
      "imageUrl": require("../static/Room/room1-MASK-Zahner2.png"),
      "imageUrl2": ""
    },
    {
      "name": "wood-rot25",
      "view": "Room",
      "scheme": 1,
      "imageUrl": require("../static/Room/room1-MASK-wood-rot25.png"),
      "imageUrl2": ""
    },
    {
      "name": "tile",
      "view": "Room",
      "scheme": 1,
      "imageUrl": require("../static/Room/room1-MASK-tile.png"),
      "imageUrl2": ""
    },
    {
      "name": "industrial",
      "view": "Room",
      "scheme": 1,
      "imageUrl": require("../static/Room/room1-MASK-industrial.png"),
      "imageUrl2": ""
    },
    {
      "name": "wood-rot30",
      "view": "Room",
      "scheme": 1,
      "imageUrl": require("../static/Room/room1-MASK-wood-rot30.png"),
      "imageUrl2": ""
    },
    {
      "name": "wood-rot27",
      "view": "Room",
      "scheme": 1,
      "imageUrl": require("../static/Room/room1-MASK-wood-rot27.png")
    },

    {
      "name": "Base",
      "view": "Room",
      "scheme": 2,
      "imageUrl": require("../static/Room/room2-BASE.png")
    },
    {
      "name": "MULTIPLY",
      "view": "Room",
      "scheme": 2,
      "imageUrl": require("../static/Room/room2-MULTIPLY.png")
    },
    {
      "name": "zPrime",
      "view": "Room",
      "scheme": 2,
      "imageUrl": require("../static/Room/room2-MASK-Zahner1.png")
    },
    {
      "name": "zSec",
      "view": "Room",
      "scheme": 2,
      "imageUrl": require("../static/Room/room2-MASK-Zahner2.png")
    },
    {
      "name": "wood-25",
      "view": "Room",
      "scheme": 2,
      "imageUrl": require("../static/Room/room2-MASK-wood-rot25.png")
    },
    {
      "name": "tile",
      "view": "Room",
      "scheme": 2,
      "imageUrl": require("../static/Room/room2-MASK-tile.png")
    },
    {
      "name": "industrial",
      "view": "Room",
      "scheme": 2,
      "imageUrl": require("../static/Room/room2-MASK-industrial.png")
    },
    {
      "name": "wood-30",
      "view": "Room",
      "scheme": 2,
      "imageUrl": require("../static/Room/room2-MASK-wood-rot30.png")
    },
    {
      "name": "wood-27",
      "view": "Room",
      "scheme": 2,
      "imageUrl": require("../static/Room/room2-MASK-wood-rot27.png")
    },
    {
      "name": "zSecIW",
      "view": "Room",
      "scheme": 2,
      "imageUrl": require("../static/Room/room2-MASK-ImageWall.png")
    },

    {
      "name": "Base",
      "view": "Room",
      "scheme": 3,
      "imageUrl": require("../static/Room/room3-BASE.png")
    },
    {
      "name": "MULTIPLY",
      "view": "Room",
      "scheme": 3,
      "imageUrl": require("../static/Room/room3-MULTIPLY-shadow.png")
    },
    {
      "name": "zPrime",
      "view": "Room",
      "scheme": 3,
      "imageUrl": require("../static/Room/room3-MASK-Zahner1.png")
    },
    {
      "name": "zSec",
      "view": "Room",
      "scheme": 3,
      "imageUrl": require("../static/Room/room3-MASK-Zahner2.png")
    },
    {
      "name": "wood-rot27",
      "view": "Room",
      "scheme": 3,
      "imageUrl": ''
    },
    {
      "name": "tile",
      "view": "Room",
      "scheme": 3,
      "imageUrl": require("../static/Room/room3-MASK-tile.png")
    },
    {
      "name": "industrial",
      "view": "Room",
      "scheme": 3,
      "imageUrl": require("../static/Room/room3-MASK-industrial.png")
    },
    {
      "name": "wood-rot30",
      "view": "Room",
      "scheme": 3,
      "imageUrl": require("../static/Room/room3-MASK-wood-rot30.png")
    },
    {
      "name": "wood-rot27",
      "view": "Room",
      "scheme": 3,
      "imageUrl": require("../static/Room/room3-MASK-wood-rot27.png")
    }
    
  ]
  

  export default sceneBuild;